module.exports = __webpack_public_path__ + "img/pusta-polka.0a46daba.png";